import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAdvanceInfo, setAdvanceInfo } from '../../hooks/apiHandler';
import { useAuth } from '../../hooks/useAuth';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const AdvanceSettingDevices = () => {
  const { state } = useLocation();
  const theme = useTheme();
  const isMdOrLg = useMediaQuery(theme.breakpoints.up('md'));
  const { Logout } = useAuth();
  const [editMode, setEditMode] = useState(false);
  const [layout, setLayout] = useState([]);
  const [printerOptions, setPrinterOptions] = useState([]);
  const [categoryOptions, setCatg] = useState(["Final Receipt", "All Categories"]);
  const navigate = useNavigate();

  const [advset, setAdvset] = useState({
    layout: "0",
    drawerRecptEnabled: false,
    recipPrinterName: '',
    kitchPrint: [{ printerName: '', categories: [] }],
  });

  useEffect(() => {
    async function calladv() {
      try {
        const response = await getAdvanceInfo({ storeID: state?.storeid, deviceid: state?.id }, Logout);

        if (response?.data) {
          const data = response.data;
          console.log(data);
          // Map layout names
          setLayout(data.layout || []);

          // Extract category strings and append (avoiding duplicates)
          const fetchedCats = (data.catgorys || []).map((cat) => cat.catgory);
          setCatg((prev) => [
            ...new Set([...prev, ...fetchedCats])
          ]);

          // Set printer options
          console.log(data.listofStorePrinter);
          console.log(data.deviceAdvSetting);
          if (data.deviceAdvSetting &&
            Object.keys(data.deviceAdvSetting).length > 0) {
            setAdvset(data.deviceAdvSetting);
          } else {
            console.log('Skip to Update');
          }
          setPrinterOptions(data.listofStorePrinter || []);

        }
      } catch (err) {
        console.error('Failed to fetch advance info:', err);
      }
    }

    calladv();
  }, [state, Logout]);

  const handleSave = async () => {
    try {
      var resp = await setAdvanceInfo({ storeID: state?.storeid, deviceid: state?.id, advset }, Logout);
      console.log(resp);
      setAdvset(resp.data);
      setEditMode(false);
    } catch (err) {
      console.error('Failed to save settings:', err);
    }
  };

  return (
    <Box sx={{ width: isMdOrLg ? '70%' : '100%', p: 2 }}>
      <ArrowBackIcon sx={{ color: '#222', borderRadius: '100%', border: '1px solid #222', fontSize: '32px' }}
        onClick={() => navigate("/admin/settings?tab=2")}></ArrowBackIcon>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography variant="h5">{state?.name}</Typography>
        </Grid>
        <Grid item xs={12} md="auto">
          {editMode && <Button onClick={() => setEditMode(false)}>Cancel</Button>}
          {!editMode && <Button variant="outlined" onClick={() => setEditMode(true)}>Edit</Button>}
          {editMode && <Button variant="contained" onClick={handleSave}>Save</Button>}
        </Grid>
      </Grid>

      <hr />
      <Typography variant="h6" sx={{ mt: 2 }}>Layout Setting:</Typography>

      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth variant="filled">
            <InputLabel>Layout</InputLabel>
            <Select
              size="small"
              value={advset.layout}
              onChange={(e) =>
                setAdvset((prev) => ({ ...prev, layout: e.target.value }))
              }
              disabled={!editMode}
            >
              <MenuItem value="0" >None</MenuItem>
              {layout.map((item, idx) => (
                <MenuItem key={idx} value={item.planName}>
                  {item.planName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Typography variant="h5" sx={{ mt: 4 }}>
        Printer Settings:
      </Typography>
      <br />
      <p>Drawer Recipts:</p>
      <FormControlLabel
        control={
          <Switch
            checked={advset.drawerRecptEnabled}
            onChange={(e) =>
              setAdvset((prev) => ({
                ...prev,
                drawerRecptEnabled: e.target.checked,
              }))
            }
            disabled={!editMode}
          />
        }
        label="Enable Drawer Receipt"
      />
      <br />
      <br />
      <p>Select Printer For Final Recipt (sales recipt)</p>
      {/* <Autocomplete
            multiple
            size="small"
            options={categoryOptions}
            value={advset.recipPrint.categories}
            onChange={(_, newValue) =>
              setAdvset((prev) => ({
                ...prev,
                recipPrint: {
                  ...prev.recipPrint,
                  categories: newValue,
                },
              }))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Categories"
                placeholder="Select categories"
              />
            )}
            disabled={!editMode} 
          />*/}

      <FormControl fullWidth variant="outlined">
        <Select
          size="small"
          value={advset.recipPrinterName}
          onChange={(e) =>
            setAdvset((prev) => ({
              ...prev,
              recipPrinterName: e.target.value
            }))
          }
          disabled={!editMode}
        >
          <MenuItem value="">None</MenuItem>
          {printerOptions.map((p) => (
            <MenuItem key={p._id} value={p.name}>
              {p.name || 'Unnamed Printer'}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography variant="h6" sx={{ mt: 4 }}>Kitchen Recipts</Typography>

      <Button
        variant="outlined"
        onClick={() => {
          if (advset.kitchPrint.length < 5) {
            setAdvset((prev) => ({
              ...prev,
              kitchPrint: [...prev.kitchPrint, { printerName: '', categories: [] }],
            }));
          }
        }}
        disabled={!editMode || advset.kitchPrint.length >= 5}
        sx={{ mb: 2 }}
      >
        + Add More
      </Button>

      {advset.kitchPrint.map((kp, index) => (
        <>
          <Grid container spacing={2} key={index} alignItems="center">
            <Grid item xs={12} md={4}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Select Printer</InputLabel>
                <Select
                  size="small"
                  value={kp.printerName}
                  onChange={(e) =>
                    setAdvset((prev) => {
                      const updated = [...prev.kitchPrint];
                      updated[index].printerName = e.target.value;
                      return { ...prev, kitchPrint: updated };
                    })
                  }
                  disabled={!editMode}
                  label="Select Printer"
                >
                  <MenuItem value="">None</MenuItem>
                  {printerOptions.map((p) => (
                    <MenuItem key={p._id} value={p.name}>
                      {p.name || 'Unnamed Printer'}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={8}>
              <Autocomplete
                multiple
                size="small"
                options={categoryOptions}
                value={kp.categories}
                onChange={(_, newValue) =>
                  setAdvset((prev) => {
                    const updated = [...prev.kitchPrint];
                    updated[index].categories = newValue;
                    return { ...prev, kitchPrint: updated };
                  })
                }
                renderInput={(params) => (
                  <TextField {...params} label="Categories" placeholder="Select" />
                )}
                disabled={!editMode}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              {editMode && (
                <Button
                  color="error"
                  variant="text"
                  onClick={() =>
                    setAdvset((prev) => {
                      const updated = [...prev.kitchPrint];
                      updated.splice(index, 1);
                      return { ...prev, kitchPrint: updated };
                    })
                  }
                  startIcon={<Delete />}
                >
                  Delete
                </Button>
              )}
            </Grid>
          </Grid>
          <br />
        </>
      ))}
    </Box>
  );
};
